// Ticket 20: Lounge Time Tracking Hook
// Now uses EntitlementsProvider for consistency
import { useEffect, useRef, useMemo } from 'react';
import { reportLoungeSession } from '../api/lounge';
import { useEntitlementsSafe } from '../context/EntitlementsContext';

export function useLoungeTime(roomId = 'flirty') {
  const { entitlements, getLimit, isPremium } = useEntitlementsSafe();
  const startRef = useRef(null);

  // Calculate remaining time from entitlements (computed, not state)
  const { remainingSeconds, limitReached, isElite } = useMemo(() => {
    if (!entitlements) {
      return { remainingSeconds: null, limitReached: false, isElite: false };
    }
    
    const dailyLimitMinutes = getLimit('lounge_minutes_per_day');
    const usageSecondsToday = entitlements.lounge_usage_seconds_today || 0;
    const premium = isPremium();
    
    // All users have time limits - calculate remaining
    const max = dailyLimitMinutes * 60;
    const remain = Math.max(0, max - usageSecondsToday);
    return {
      remainingSeconds: remain,
      limitReached: remain <= 0,
      isElite: premium,
    };
  }, [entitlements, getLimit, isPremium]);

  // Track session time on unmount
  useEffect(() => {
    startRef.current = Date.now();
    
    return () => {
      const end = Date.now();
      const ms = end - (startRef.current || end);
      const seconds = Math.round(ms / 1000);
      
      if (seconds > 0) {
        console.log(`[LoungeTime] Reporting lounge session: ${seconds}s in room ${roomId}`);
        reportLoungeSession(seconds, roomId).catch((err) => {
          console.error('[LoungeTime] Failed to report session', err);
        });
      }
    };
  }, [roomId]);

  return {
    entitlements,
    remainingSeconds,
    limitReached,
    isElite,
  };
}
